export const KEYBOARD_SHORTCUTS = {
  openPayment: 'F2',
  fullCardPayment: 'F3',
  fullCashPayment: 'F2',
  newSale: 'F4',
  searchProducts: 'F9',
  searchCustomers: 'F10',
  enterCash: 'F4',
  confirmPayments: 'F8',
  printFromConfirmation: 'Enter',
  newSaleFromConfirmation: 'F4',
  confirmCheck: 'F8',
  delete: 'Del',
  clearAmount: 'Del',
  clearAmountAlt: 'Backspace',
  backspace: 'Backspace',
  cancel: 'Escape',
  confirm: 'Enter',
  collapseAll: ['Ctrl', 'Shift', 'NumPad -'],
  expandAll: ['Ctrl', 'Shift', 'NumPad +'],
} as const;
export type KeyboardShortcuts = typeof KEYBOARD_SHORTCUTS;
export type ShortcutAction = keyof KeyboardShortcuts;
export type ShortcutKey = KeyboardShortcuts[ShortcutAction];
export type KeyboardShortcutsConf = Record<ShortcutAction, boolean>;

export const DEFAULT_SHORTCUT_CONFIGURATION: KeyboardShortcutsConf = {
  openPayment: true,
  fullCardPayment: true,
  fullCashPayment: true,
  newSale: true,
  searchProducts: true,
  searchCustomers: true,
  enterCash: true,
  confirmPayments: true,
  printFromConfirmation: true,
  newSaleFromConfirmation: true,
  confirmCheck: true,
  delete: true,
  clearAmount: true,
  clearAmountAlt: true,
  backspace: true,
  cancel: true,
  confirm: true,
  collapseAll: true,
  expandAll: true,
} as const;

const HARDCODED_ALLOWED_ACTIONS: Partial<ShortcutAction>[] = [
  'confirm',
  'cancel',
  'delete',
];
/**
 * Some of the actions (such as closing a window via Esc or submitting a form with Enter or any other actions we may want to ALWAYS allow in the future) need to always be executable and be not configurable
 */
export function getIsConfigurableShortcutAction(action: ShortcutAction) {
  return !HARDCODED_ALLOWED_ACTIONS.includes(action);
}
